import { Button } from '@sunstone/ui';
import { Brain, ChevronDown, ChevronUp } from 'lucide-react';
import { useState } from 'react';
import type { BlockRendererProps } from '../registry';

export function ThinkingBlockRenderer({ block }: BlockRendererProps) {
  const [expanded, setExpanded] = useState(false);
  const isStreaming = block.status === 'streaming';

  return (
    <div className="mt-2 text-xs">
      <Button
        type="button"
        variant="ghost"
        size="sm"
        onClick={() => setExpanded(!expanded)}
        className="h-6 px-1.5 gap-1 text-muted-foreground hover:text-foreground text-xs"
      >
        <Brain className="w-3 h-3" />
        {isStreaming ? 'Thinking...' : expanded ? 'Hide thinking' : 'Show thinking'}
        {!isStreaming &&
          (expanded ? <ChevronUp className="w-3 h-3" /> : <ChevronDown className="w-3 h-3" />)}
      </Button>
      {(expanded || isStreaming) && (
        <pre className="mt-1 whitespace-pre-wrap font-mono text-muted-foreground italic border-l-2 border-border pl-2">
          {block.content}
        </pre>
      )}
    </div>
  );
}
